import { api } from './api'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'

// Public URL to stream/preview a comment attachment (sends the auth cookie as a
// same-site request). Used as <img>/<video> src and download links.
export function attachmentUrl(fileId) {
  return `${BASE_URL}/comments/attachments/${fileId}`
}

// Upload files for a comment (multipart). Resolves to attachment descriptors
// [{ fileId, name, contentType, size }] to include when creating the comment.
export async function uploadAttachments(files) {
  const form = new FormData()
  for (const file of files) form.append('files', file)
  const res = await fetch(`${BASE_URL}/comments/attachments`, {
    method: 'POST',
    credentials: 'include',
    body: form,
  })
  if (!res.ok) {
    let message = 'Upload failed'
    try {
      const data = await res.json()
      message = data.error || message
    } catch {
      /* non-JSON error */
    }
    throw new Error(message)
  }
  return res.json().then((data) => data.attachments)
}

// Every top-level comment on any item in the standard (the whole document's
// discussion); the client filters/sorts locally.
export function listComments(standard) {
  const query = `?standard=${encodeURIComponent(standard)}`
  return api.get(`/comments${query}`).then((data) => data.comments)
}

export function listReplies(id) {
  return api.get(`/comments/${id}/replies`).then((data) => data.replies)
}

export function listLikers(id) {
  return api.get(`/comments/${id}/likes`).then((data) => data.likers)
}

// payload for a top-level comment: { itemIds: [id], text, isPublic, isQuestion }
// payload for a reply: { parent, text, isPublic, isQuestion }
export function createComment(payload) {
  return api.post('/comments', payload).then((data) => data.comment)
}

// changes may include { text, isPublic, isQuestion, itemIds }
export function updateComment(id, changes) {
  return api.patch(`/comments/${id}`, changes).then((data) => data.comment)
}

export function deleteComment(id) {
  return api.del(`/comments/${id}`).then((data) => data.comment)
}

export function likeComment(id) {
  return api.post(`/comments/${id}/like`).then((data) => data.comment)
}

export function unlikeComment(id) {
  return api.post(`/comments/${id}/unlike`).then((data) => data.comment)
}

export function saveComment(id) {
  return api.post(`/comments/${id}/save`).then((data) => data.comment)
}

export function unsaveComment(id) {
  return api.post(`/comments/${id}/unsave`).then((data) => data.comment)
}
